export default __webpack_public_path__ + "static/media/under-construction.198cde96.png";